import React from "react";

const OptionalLabel = () => (
  <span className="FormElement-optional">(optional)</span>
);

export default OptionalLabel;
